module.exports = {
	"classes": [
		"breached-passwords-page"
	],
	"title": "Breached Password Detection",
	"metas": {
		"description": ""
	},
	"opengraph": {
		"og:title": "Breached Password Detection",
		"og:description": "Breached password detection protects and notifies your users when their credentials are leaked by a data breach of a third party. You can optionally prevent access until the user has reset their password.",
		"og:url": "https://auth0.com/breached-passwords",
		"og:image": "http://cdn2.auth0.com/blog/breached-twitter-card.png",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/breached-twitter-card.png"
	},
	"twittercard": {
		"twitter:title": "Breached Password Detection",
		"twitter:description": "Breached password detection protects and notifies your users when their credentials are leaked by a data breach of a third party. You can optionally prevent access until the user has reset their password.",
		"twitter:image": [
			{
				"src": "https://cdn2.auth0.com/blog/breached-twitter-card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/jp/breached-passwords/metadata.json
// module id = 1123
// module chunks = 0